module.exports = __webpack_public_path__ + "static/img/top.de48d0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/top.png
// module id = 9S13
// module chunks = 24